import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Link } from 'carbon-components-react';
import { UpgradeModal } from 'components';
import { APP_URL } from 'types';
import { OverflowMenuHorizontal16 } from '@carbon/icons-react';

const UpgradePlanSection: React.FC<Props> = ({ viewConfirmationPDF }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const history = useHistory();

  const handleViewInMailbox = () => {
    history.push(APP_URL.MAIL_BOXES);
  };
  return (
    <div className="plan-upgrade">
      <div className="plan-upgrade-button-container">
        <Button
          className="plan-upgrade-button"
          kind="tertiary"
          renderIcon={OverflowMenuHorizontal16}
          onClick={() => setIsModalOpen(true)}
        >
          Upgrade my plan
        </Button>
      </div>
      <div className="plan-upgrade-link">
        {typeof viewConfirmationPDF === 'function' && (
          <Link onClick={() => viewConfirmationPDF()}>BYDA confirmation</Link>
        )}
        <Link onClick={handleViewInMailbox}>View responses in mailbox</Link>
      </div>
      <div className="plan-upgrade-description">
        Your free plan limit renews each month
      </div>
      <UpgradeModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </div>
  );
};

type Props = {
  viewConfirmationPDF?: Function;
};

export default React.memo(UpgradePlanSection);
